export enum AddLocationType {
  Location = 'Location',
  Customer = 'Customer'
}
